import {
  GAME_HEIGHT,
  GAME_WIDTH,
} from '../logic/gameUtils';

function getPlayfieldPosition(x, y) {
  return {
    left: `${(x / GAME_WIDTH) * 100}%`,
    top: `${(y / GAME_HEIGHT) * 100}%`,
  };
}

export default getPlayfieldPosition;
